import { render, staticRenderFns } from "./Typer.vue?vue&type=template&id=05d216fb&scoped=true&"
import script from "./Typer.vue?vue&type=script&lang=js&"
export * from "./Typer.vue?vue&type=script&lang=js&"
import style0 from "./Typer.vue?vue&type=style&index=0&id=05d216fb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05d216fb",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
